import { jsx as _jsx } from "react/jsx-runtime";
import { CsgPrimitive } from '../CsgPrimitive';
export function CSGMesh3D({ node, children }) {
    const properties = node.properties;
    return (_jsx(CsgPrimitive, { node: node, properties: properties, children: children }));
}
//# sourceMappingURL=Component.js.map